import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './message-bubble.module.scss'
import classnames from 'classnames'
import { Markdown } from '@huggg/react-components'
import { connect } from 'react-redux';
import { showDetails } from 'redux/modules/huggg';

const MessageBubble = ({ text, animate, onAnimationComplete }) => {
  const [ isInitialAnimation, setIsInitialAnimation ] = useState(animate)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialAnimation(false)
    }, calculateTimeout())
    return () => clearTimeout(timer)
  })

  const calculateTimeout = () => {
    const letterTime = text.length > 100 ? 15 : 25;
    return text.length * letterTime;
  }

  const renderInitialAnimation = () => (
    <div className={styles.dots}>
      <span className={styles.dot} >&#9679;</span>
      <span className={styles.dot} >&#9679;</span>
      <span className={styles.dot} >&#9679;</span>
    </div>
  )

  return (
    <div>
      { isInitialAnimation && renderInitialAnimation() }
      <div
        className={classnames(styles.text, isInitialAnimation ? styles.hidden : styles.shown)}
        onTransitionEnd={onAnimationComplete}
      >
        <Markdown value={text.replace(/\n/g, '  \n')} centerText />
      </div>
    </div>
  )
}

MessageBubble.defaultProps = {
  animate: true
};

MessageBubble.propTypes = {
  animate: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  onAnimationComplete: PropTypes.func
};

export default connect(
  null,
  { onAnimationComplete: showDetails }
)(MessageBubble);
